import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'

const Details = (props) => {
  const { providerForm } = props

  const {
    entityState: {
      active,
      business_number,
      email,
      phone,
      short_name,
      title,
      website,
    },
    errors,
    handlers,
  } = providerForm

  const { isAdmin } = useCurrentUser()

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row columns={isAdmin ? undefined : 'repeat(1, 1fr)'}>
          {isAdmin && (
            <Form.Field label="Active">
              <select
                data-value-type="boolean"
                name="active"
                value={active}
                {...handlers}
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </Form.Field>
          )}

          <Form.Field
            boxProps={{ width: !isAdmin ? '100%' : undefined }}
            errorMessage={errors.title}
            label="Title"
            marginTop={isAdmin ? ['large', 0] : 0}
          >
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.phone} label="* Phone">
            <input name="phone" type="text" value={phone} {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.website} label="Website" marginTop={['large', 0]}>
            <input name="website" type="text" value={website} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Short Name">
            <input name="short_name" type="text" value={short_name} {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.business_number} label="ABN" marginTop={['large', 0]}>
            <input name="business_number" type="text" value={business_number} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.email} label="Email(s)">
            <textarea
              name="email"
              style={{ height: 60, resize: 'vertical' }}
              type="text"
              value={email}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

Details.propTypes = {
  providerForm: PropTypes.object.isRequired,
}

export default Details
